import { computed } from '@angular/core';
import { signalStore, withComputed } from '@ngrx/signals';
import { PromotionItemPrice } from '@idealsupply/products-api-angular-client';
import { withItemPricing, withItemStockStore } from 'products-data';
import { PUNCHOUT_PROMO_ID } from '../constants';

export const PunchoutItemPricingComponentStore = signalStore(
  withItemPricing(),
  withItemStockStore(),

  withComputed((store) => ({
    isPunchoutPromo: computed(() => {
      const sale = store.itemPricing()?.pricing.sale;
      return !sale ? false : sale.type === 'promotion' && (sale as PromotionItemPrice).promotionId === PUNCHOUT_PROMO_ID;
    }),
  })),
);

export type PunchoutItemPricingComponentStore = InstanceType<typeof PunchoutItemPricingComponentStore>;
